/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Box, Button, Chip, CircularProgress, Divider, Grid, MenuItem, Modal, TextField, Typography } from '@mui/material';
import { gridSpacing } from 'store/constant';
import AddUser from '../components/admin/addUser';
import ListUsers from 'components/admin/listUsers';
import MainCard from 'ui-component/cards/MainCard';
import AnimateButton from 'ui-component/extended/AnimateButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useNavigate } from 'react-router-dom';
import { SET_SIDE_MENU } from 'store/actions';
// import { fetchAdvertiserList } from '../../redux/advertiser/advertiserActions';
import { checkUserAlreadyExist, onboardUserToDashboard, resetIAMFormData, sendIAMInvite } from '../redux/user/userActions';
import { fetchAdvertiserList } from '../redux/advertiser/advertiserActions';
const AddNewUser = ({
  sendIAMInvite,
  onboardedIAMStatus,
  onboardedToDashboard,
  resetIAMFormData,
  iamUserList,
  checkUserAlreadyExist,
  userLoginForDashboardAlreadyExist,
  onboardUserToDashboard,
  showModal,
  closeModal,
  error
}) => {
  const [open, setOpen] = React.useState(showModal);
  const [loadingOB, setLoadingOB] = useState(false);
  const [loadingIAM, setLoading] = useState(false);
  const [value, setValue] = React.useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    sfid: '',
    advertiserName: '',
    advertiserGuid: '',
    timezone: '',
    platform: ''
  });
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    sfid: '',
    advertiserGuid: '',
    message: '',
    advertiserName: '',
    timezone: '',
    platform: ''
  });
  // const [selected_advertisers, setSelected_advertisers] = React.useState([]);
  // const handleOpen = () => {
  //   setOpen(true);
  // };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => {
    // setOpen(false);
    // closeModal(false);
    resetIAMFormData();
    navigate('/advertisers', { replace: true });
  };
  useEffect(() => {
    dispatch({ type: SET_SIDE_MENU, showSideMenu: false });
    localStorage.setItem('showSideMenu', false);
  }, [dispatch]);
  useEffect(() => {
    console.log('checkUserAlreadyExistOnDashboard', userLoginForDashboardAlreadyExist);
    if (userLoginForDashboardAlreadyExist == true) {
      console.log('prev Error', errors.email);
      let prevError = errors.email;
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: prevError
      }));
    }
  }, [userLoginForDashboardAlreadyExist, errors.email]);
  // const renderTags = (value1, getTagProps) => {
  //   return (
  //     <>
  //       {value.map((option, index) => (
  //         <Chip {...getTagProps({ index })} key={index} label={option.name} onDelete={() => handleDelete(option)} />
  //       ))}
  //       {/* {value.length > 2 && (
  //             <span>
  //               {"+"}
  //               {value.length - 2} more
  //             </span>
  //           )} */}
  //     </>
  //   );
  // };
  const handleDelete = (deletedOption) => {
    //console.log(deletedOption,value)
    const newValue = value.filter((option) => option !== deletedOption);
    setValue(newValue);
  };

  const validateEmail = (email) => {
    // First check if it's a valid email format
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(String(email).toLowerCase())) {
      return { isValid: false, message: 'Invalid email address' };
    }

    // Then check if it's an inmobi.com email
    if (email.toLowerCase().endsWith('@inmobi.com')) {
      return { isValid: false, message: 'Enter valid email id' };
    }

    return { isValid: true, message: '' };
  };

  // Check user already IAM onboarded or not
  const checkEmailExist = (email) => {
    // console.log(email);
    // console.log(iamUserList)
    const emailExist = iamUserList.some((iamUser) => iamUser.email === email);
    // console.log(emailExist)
    return emailExist;
  };
  //Check whether user is already onboarded to Dashboard Backend
  const checkUserAlreadyExistOnDashboard = (email) => {
    let status;
    if (email != '') {
      status = checkUserAlreadyExist(email);
    }
    return status;
  };
  const validateField = (name, value) => {
    let error = '';
    if (name === 'dropdown' && value.length === 0) {
      console.log('inside this');
      error = 'At least one option must be selected';
      //isValid = false;
    } else if (name === 'name' && value.trim() === '') {
      error = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    } else if (name === 'advertiserGuid' && value.trim() === '') {
      error = `Advertiser Guid is required`;
    } else if (name === 'advertiserName' && value.trim() === '') {
      error = `Advertiser Name is required`;
    } else if (name === 'email') {
      const emailValidation = validateEmail(value);
      if (!emailValidation.isValid) {
        error = emailValidation.message;
      } else if (checkEmailExist(value)) {
        error = 'Email Already Exist ON IAM';
      }
    } else if (name === 'sfid' && value.trim() === '') {
      error = `SF Id is required`;
    } else if ((name === 'timezone' || name === 'platform') && !value) {
      error = `${name} is required`;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error
    }));
    // if (name === 'email' && validateEmail(value) == true) {
    //   console.log('valid email');
    //   let userExist = checkUserAlreadyExistOnDashboard(value);
    //   console.log(userExist);
    // }
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value
  //   });
  //   validateField(name, value);
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    validateField(name, value);
  };
  // const handleAutocompleteChange = (event, value) => {
  //   setValue(value);
  //   const selectedIds = value.map((item) => item.id);
  //   setSelected_advertisers(selectedIds);
  //   validateField('dropdown', selectedIds);
  // };
  const handleOnboardUserToDashboard = () => {
    // Validate email before proceeding
    const emailValidation = validateEmail(formData.email);
    if (!emailValidation.isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: emailValidation.message
      }));
      return;
    }

    let formattedData = {
      advertisers: [
        {
          name: formData.advertiserName,
          id: formData.advertiserGuid,
          sfId: formData.sfid,
          timezone: formData.timezone,
          platform: formData.platform
        }
      ],
      email_id: formData.email,
      role: 'client'
    };
    //console.log(formattedData);
    setLoadingOB(true);
    onboardUserToDashboard(formattedData);
    setTimeout(() => {
      setLoadingOB(false);
    }, 4000);
    // let onboard_advertiser_list=advertiserList.filter(advertiser=>selected_advertisers.includes(advertiser.id))
    // console.log(onboard_advertiser_list)
  };
  const handleIAMInviteSend = () => {
    console.log('iam invite');
    // Validate email before proceeding
    const emailValidation = validateEmail(formData.email);
    if (!emailValidation.isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: emailValidation.message
      }));
      return;
    }

    if (formData.name != '' && formData.email != '') {
      setLoading(true);
      sendIAMInvite(formData);
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  return (
    <>
      <MainCard>
        <Grid container spacing={gridSpacing}>
          <Grid item lg={3} md={2} sm={2} xs={2}></Grid>
          <Grid item lg={5} md={4} sm={4} xs={5}>
            {/* <SearchBar/> */}
            {/* <AnimateButton>
            <Button
              disableElevation
              disabled={false}
              fullWidth
              size="large"
              type="submit"
              variant="outlined"
              color="secondary"
              onClick={handleOpen}
            >
              Add User
            </Button>
          </AnimateButton> */}

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography id="modal-title" variant="h5" align="center">
                  Add New Client User Details
                </Typography>
                <Divider sx={{ my: 1 }} />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  autoFocus
                  fullWidth
                  name="name"
                  label="Enter First Name & Last Name"
                  value={formData.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="email"
                  label="Email Address"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="advertiserName"
                  label="Advertiser Name"
                  value={formData.advertiserName}
                  onChange={handleChange}
                  error={!!errors.advertiserName}
                  helperText={errors.advertiserName}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="sfid"
                  label="Sf Id"
                  value={formData.sfid}
                  onChange={handleChange}
                  error={!!errors.sfid}
                  helperText={errors.sfid}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="advertiserGuid"
                  label="Advertiser Guid"
                  value={formData.advertiserGuid}
                  onChange={handleChange}
                  error={!!errors.advertiserGuid}
                  helperText={errors.advertiserGuid}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  name="timezone"
                  label="Select Timezone"
                  value={formData.timezone}
                  onChange={handleChange}
                  error={!!errors.timezone}
                  helperText={errors.timezone}
                >
                  <MenuItem value="UTC">UTC</MenuItem>
                  <MenuItem value="JST">JST</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  name="platform"
                  label="Select Platform"
                  value={formData.platform}
                  onChange={handleChange}
                  error={!!errors.platform}
                  helperText={errors.platform}
                >
                  <MenuItem value="DSP">DSP</MenuItem>
                  <MenuItem value="IAP Offline">IAP Offline</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item>
                    <Button onClick={handleClose} color="primary">
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button onClick={handleOnboardUserToDashboard} color="primary">
                      {loadingOB ? <CircularProgress size={20} /> : 'Onboard User'}
                    </Button>
                    {onboardedToDashboard && (
                      <CheckCircleIcon
                        stroke={1.5}
                        size="1rem"
                        style={{
                          marginTop: 'auto',
                          marginBottom: 'auto',
                          color: '#22ae2d'
                        }}
                      />
                    )}
                    {error === 'User Onboarding Failed' && !onboardedToDashboard && (
                      <CancelIcon
                        stroke={1.5}
                        size="1rem"
                        style={{
                          marginTop: 'auto',
                          marginBottom: 'auto',
                          color: '#e53935' // red color for error
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item>
                    <Button onClick={handleIAMInviteSend} color="primary">
                      {loadingIAM ? <CircularProgress size={24} /> : 'Send IAM Invite'}
                    </Button>
                    {onboardedIAMStatus && (
                      <CheckCircleIcon
                        stroke={1.5}
                        size="1rem"
                        style={{
                          marginTop: 'auto',
                          marginBottom: 'auto',
                          color: '#22ae2d'
                        }}
                      />
                    )}
                    {error === 'Unable To Onboard IAM' && !onboardedIAMStatus && (
                      <CancelIcon
                        stroke={1.5}
                        size="1rem"
                        style={{
                          marginTop: 'auto',
                          marginBottom: 'auto',
                          color: '#e53935' // red color for error
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {errors.message && (
                <Grid item xs={12}>
                  <Typography color="error">{errors.message}</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item lg={3} md={3} sm={3} xs={3}></Grid>
        </Grid>
        {/* <AddUser/> */}
      </MainCard>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.advertiserReducer.loading,
    error: state.advertiserReducer.error,
    advertiserList: state.advertiserReducer.advertiser_list,
    onboardedIAMStatus: state.userReducer.onboardedIAM,
    onboardedToDashboard: state.userReducer.onboardedToDashboard,
    iamUserList: state.userReducer.iamUserList,
    userLoginForDashboardAlreadyExist: state.userReducer.userLoginForDashboardAlreadyExist
  };
};
const mapDispatchToProps = {
  fetchAdvertiserList: fetchAdvertiserList,
  sendIAMInvite: sendIAMInvite,
  resetIAMFormData: resetIAMFormData,
  checkUserAlreadyExist: checkUserAlreadyExist,
  onboardUserToDashboard: onboardUserToDashboard
};
export default connect(mapStateToProps, mapDispatchToProps)(AddNewUser);
